class Rail {
    deviceType= "rail";
    code= "";
    description= "";
    manufacturer= "";
    weight= 0;
    length = 0; //rail length (mm)
    unit = "peça(s)";
    product = { 
      price:0,
      cost:0,
      // taxes:0,
      sellerId:"", //Now its a string
      available:true, //editted by the user
       unit : "peça(s)",
      quantity:0,
      we:{
        ativoMatriz:false,
        ativoIntegrador:false,
        ativoFranquia:false,
        custoUsdAtivo:false,
        custoUsd:0,
        precoTargetUsd:0,

      }

   };

    constructor() {
    };
   


    calc(){
   
    }

    //calular inversor
}




export default Rail;
